export enum ContentExclusionType {
    Include = 1,
    Exclude = 2,
}

export const CONTENT_EXCLUSION_TYPE_OPTIONS = [
    { key: ContentExclusionType.Include, value: ContentExclusionType.Include, text: 'Include' },
    { key: ContentExclusionType.Exclude, value: ContentExclusionType.Exclude, text: 'Exclude' },
];

export const getContentExclusionTypeLabel = (type: ContentExclusionType): string =>
    type === ContentExclusionType.Include ? 'Include' : 'Exclude';
